import { documentPath } from "../api/paths";
import type { DocumentTokenArgs } from "../api/types";

/** Excel's "open for edit" protocol handler, followed by the URL it fetches. */
const MS_EXCEL_OPEN_FOR_EDIT_PREFIX = "ms-excel:ofe|u|";

const withoutTrailingSlash = (url: string) => url.replace(/\/+$/, "");

type ExcelOpenUriArgs = DocumentTokenArgs & {
	baseUrl: string;
	token: string;
	filename: string;
};

/** Ends in the filename so Excel names the workbook after it, not "Book1". */
export const buildExcelOpenUri = ({
	baseUrl,
	token,
	filename,
	...documentRef
}: ExcelOpenUriArgs) =>
	`${MS_EXCEL_OPEN_FOR_EDIT_PREFIX}${withoutTrailingSlash(baseUrl)}${documentPath(documentRef)}/open/${encodeURIComponent(token)}/${encodeURIComponent(filename)}`;

type DocumentViewUrlArgs = DocumentTokenArgs & {
	baseUrl: string;
	token: string;
};

export const buildDocumentViewUrl = ({
	baseUrl,
	token,
	...documentRef
}: DocumentViewUrlArgs) =>
	`${withoutTrailingSlash(baseUrl)}${documentPath(documentRef)}/view?t=${encodeURIComponent(token)}`;
